'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { Addresses } from 'my-purchases/components/Addresses/Addresses'
import { OrderHeader } from 'my-purchases/components/OrderHeader/OrderHeader'
import { OrderIdentifier } from 'my-purchases/components/OrderIdentifier/OrderIdentifier'
import { OrderTrackingNumber } from 'my-purchases/components/OrderTrackingNumber/OrderTrackingNumber'
import { PurchaseDate } from 'my-purchases/components/PurchaseDate/PurchaseDate'
import { PurchasePaymentInfo } from 'my-purchases/components/PurchasePaymentInfo/PurchasePaymentInfo'
import { StorePurchaseInfo } from 'my-purchases/components/StorePurchaseInfo/StorePurchaseInfo'
import { ORDER_TYPES } from 'my-purchases/constants/orderTypes'
import { PAYMENT_TYPES } from 'my-purchases/constants/paymentTypes'
import { ReturnsContainer } from 'my-purchases/containers/ReturnsContainer/ReturnsContainer'
import type { OrderDetails } from 'my-purchases/types/purchaseDetail'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'

import styles from './OrderDetailInfoContainer.module.scss'

interface OrderDetailInfoContainerProps {
	readonly order: OrderDetails
	readonly type: ORDER_TYPES
	readonly orderIndex: number
	readonly isMulti: boolean
	readonly statusOnHeader: boolean
}
export function OrderDetailInfoContainer({
	order,
	type,
	orderIndex,
	isMulti,
	statusOnHeader,
}: OrderDetailInfoContainerProps) {
	const { t } = useLabels()

	const { isSmall } = useResponsive()

	const { id, creationDateTime } = order

	return (
		<>
			{!statusOnHeader && (
				<OrderHeader
					order={order}
					orderIndex={orderIndex}
					showMultiTitle={isMulti}
					className={styles.header}
				/>
			)}

			<OrderIdentifier
				orderId={id}
				className={styles.infoContent}
				type={type}
			/>

			{order?.paymentMethod !== PAYMENT_TYPES.BOPO && (
				<OrderTrackingNumber order={order} className={styles.infoContent} />
			)}

			<PurchaseDate date={creationDateTime} className={styles.infoContent} />
			<ReturnsContainer order={order} className={styles.infoContent} />

			{!isSmall && (
				<>
					{type === ORDER_TYPES.ONLINE ? (
						<Addresses order={order} className={styles.infoContent} />
					) : (
						<>
							<div
								className={styles.infoContent}
								data-testid='myPurchases.store.details.purchaseDetails'
							>
								<h2>{t('myPurchases.store.details.purchaseData.title')}</h2>
								<StorePurchaseInfo order={order} />
							</div>
							<div
								className={styles.infoContent}
								data-testid='myPurchases.store.details.paymentDetails'
							>
								<h2>{t('myPurchases.store.details.paymentDetails.title')}</h2>
								<PurchasePaymentInfo order={order} />
							</div>
						</>
					)}
				</>
			)}
		</>
	)
}
